<template>
<div  class="delete-container">
  <div class="delete-content">
    <i class="el-icon-close close-icon" @click="cancleDelete"></i>
    <!-- <div class="delete-title">
      <i class="el-icon-warning"></i>
      提示
    </div> -->
    <p class="delete-txt">确认要删除此数据?</p>
    <div class="btn-container">
      <el-button class="btn-list cancle-btn" @click="cancleDelete">取消</el-button>
      <el-button class="btn-list sure-btn" @click="sureDelete">确认</el-button>
    </div>
  </div>
</div>
</template>

<script type='text/ecmascript-6'>
export default {
  methods: {
    cancleDelete () { // 取消删除
      this.$emit('delete', 'cancle')
      this.$message({
        type: 'info',
        message: '取消删除此数据！',
        customClass: 'msg-position',
        showClose: true
      })
    },
    sureDelete () { // 确认删除
      this.$emit('delete', 'sure')
    }
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus' scoped>
.delete-container
  position:fixed;
  left:0;
  right:0;
  top:0;
  bottom:0;
  background-color:rgba(0, 0, 0, 0.2);
  z-index:10000;
  display: flex;
  justify-content: center;
  align-items: center;
  .delete-content
    background:#fff;
    z-index: 100001;
    width: 20rem;
    padding: 2rem 1rem;
    border-radius: 0.4rem;
    position: relative;
    .delete-title
      text-align:center;
      font-size:0.8rem;
      .el-icon-warning
        color:red;
        font-size:1rem;
    .delete-txt
      text-align: center;
      margin-top:1rem;
      font-size:0.9rem;
      font-weight:medium;
      color:#666;
    .btn-container
      margin-top:1.5rem;
      padding: 0rem 2rem;
      width:100%;
      color: #666;
      box-sizing:border-box;
      display: flex;
      .btn-list
        flex:1;
        color:#fff;
        border:0;
        &.cancle-btn
          background: #cfcfcf;
          color:#fff;
          span
            color:#fff;
        &.sure-btn
          background: #EF757A;
          span
            color:#fff;
    .close-icon
      position: absolute;
      top:0.5rem;
      right:0.5rem;
      color:#9a9a9a;
      font-size:1.2rem;
</style>
